/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import MetricsRedux from "./../metrics/MetricsRedux";
import { Metric as metricApi} from "./../metricpalettecode/api/deviceMetrics/metric";

const MetricViewUrl = ({ match }) => {
  const [metricTypeWithId, setMetricTypeWithId] = useState(null);

  useEffect(() => {
    metricApi
      .getNamedMetricsById({ id: match.params.id })
      .then(({ data }) => {
        if (data.csId !== null) {
          setMetricTypeWithId({
            groupId: undefined,
            csId: data.csId,
          })
        } else if (data.groupId !== null) {
          setMetricTypeWithId({
            groupId: data.groupId,
            csId: undefined,
          })
        }
      })
      .catch(console.error);
  }, [match.params.id]);

  return (
    <div style={{
      margin: 0,
      padding: 0,
      width: '100%',
      boxSizing: 'border-box',
      height: '100%',
      backgroundColor: 'white'
    }}>
      {metricTypeWithId === null ? <p>Fetching...</p> : (
        <MetricsRedux
          groupId={metricTypeWithId.groupId}
          csId={metricTypeWithId.csId}
          metricId={match.params.id}
          fromUrl
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    saas: state.saas,
    acl: state.acl,
    ocviews: state.ocviews,
  };
};

export default connect(mapStateToProps, null)(MetricViewUrl);